import type { MealEntity } from './entity/mealEntity';
import type { MealIRepository } from './entity/mealIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 食事ドメインサービス
 */
export class MealDomainService extends DomainServiceBase {
  private mealRepository!: MealIRepository;

  /**
   * Injection
   * @param mealRepository mealRepository
   */
  public inject(
    mealRepository: MealIRepository,
  ) {
    this.mealRepository = mealRepository;
  }

  /**
   * 食事リスト取得
   * @param token トークン
   * @returns リスト
   */
  async getMealList(token: string | null) {
    const result = await this.mealRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: MealEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** 食事リスト */
      items,
    };
  }

  /**
   * 指定日の食事リスト取得
   * @param date 日付
   * @returns リスト
   */
  async getMealListWithDate(date: string) {
    const result = await this.mealRepository.getAllListWithKey(date);
    const items = result.map((v: MealEntity) => v.toJson());
    return items;
  }

  /**
   * 食事作成
   * @param entity 入力
   * @returns 結果
   */
  async createMeal(
    entity: MealEntity,
  ) {
    const result = await this.mealRepository.create(entity);
    return result;
  }

  /**
   * 食事更新
   * @param entity 入力
   * @returns 結果
   */
  async updateMeal(
    entity: MealEntity,
  ) {
    const result = await this.mealRepository.update(entity);
    return result;
  }

  /**
   * 食事削除
   * @param entity 入力
   * @returns 結果
   */
  async deleteMeal(
    entity: MealEntity,
  ) {
    const result = await this.mealRepository.delete(entity);
    return result;
  }
}
